<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6 text-left">
                <button class="btn btn-outline-dark btn-sm" @click="openProvinceModal">
                  <i class="fa fa-plus"></i>
                  Asignar Provincias
                </button>
              </div>
            </div>

            <!-- Lista de provincias -->
            <div style="overflow-y: auto; max-height: 60vh;overflow-x:hidden;">
              <table class="table" id="list">
                <thead class="thead-light">
                  <tr>
                    <th>Provincia</th>
                    <th class="text-center">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="province in myProvinces"
                    v-bind:key="province.id"
                  >
                    <td>
                      <a href="#" @click="selectProvince(province)">{{ province.name }}</a>
                    </td>
                    <td class="text-center">
                      <a
                        title="Eliminar"
                        @click="deleteProvince(province)"
                        href="#"
                        class="text-danger"
                      >
                        <i class="fa fa-trash fa-2x"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Loader -->
              <div v-show="inRequest ">
                <div class="text-center">
                  <Loader />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal de provincias -->
    <div
      class="modal fade"
      id="provinces-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="provinces-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Seleccione las provincias</h5>
            <button type="button" class="close" v-on:click="closeProvinceModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <h6>
              Provincias seleccionadas
              <b>({{ getSelectedProvincesId.length }})</b>
            </h6>

            <a @click="selectAllProvince" href="#" class="main-blue">
              <div v-if="allProvinceSelected">Deseleccionar todas</div>
              <div v-else>Seleccionar todas</div>
            </a>
            <div class="list-group vscroll" style="overflow-y:auto;max-height:350px;">
              <a
                @click="province.selected = !province.selected"
                v-for="province in provinces"
                :value="province.id"
                :key="province.id"
                href="#"
                :style="province.selected ? 'background-color: #CECECE;font-weight:bold;': ''"
                class="list-group-item list-group-item-action"
              >{{ province.name }}</a>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-sm-12">
                <button
                  :disabled="inRequest"
                  class="btn btn-danger"
                  v-on:click="closeProvinceModal"
                >
                  <i class="fa fa-ban"></i>
                  Cancelar
                </button>
                

                <button :disabled="inRequest" class="btn main-green-bg ml-2" v-on:click="saveProvinces">
                  <i class="fa fa-save"></i>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Final Modal -->


    <!-- Zonas -->
    <div class="modal fade" 
      id="zones-modal" 
      tabindex="-1"
      role="dialog"
      aria-labelledby="zones-modal-header"
      aria-hidden="true">
      <div class="modal-dialog modal-sm" role="document">

        <div class="modal-content" style="width: 400px;">

          <div class="modal-header">
            <h4 style="margin:0;" id="zones-modal-header">Zonas <b>{{ selectedProvince.name }}</b></h4>
          </div>
          <div class="modal-body">

            <ul class="list-group vscroll" style="overflow-y:auto;max-height:350px;">
              <li
                @click="z.selected = !z.selected"
                v-for="z in zones"
                :value="z.id"
                :key="z.id"
                href="#"
                :class="z.selected ? 'list-group-item bg-success' : 'list-group-item'"
              >{{ z.name }}</li>
            </ul>

          </div>
          <div class="modal-footer">
            <button
              :disabled="inRequest"
              class="btn btn-danger"
              v-on:click="closeZoneModal"
            >
              <i class="fa fa-ban"></i>
              Cancelar
            </button>

            <button :disabled="inRequest"  @click="updateZones" class="btn main-bg ml-2">Guardar</button>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import firebase from "firebase/app";
import { BranchOfficeService } from '../../services/BranchOfficeService';
import { UtilsService } from '../../services/UtilsService';
import Loader from './Loader';
export default {
  components: { Loader },
  name: "ProvinceBranchOffices",
  props: ["companyId","branchOfficeId"],
  data: function () {
    return {
      db: firebase.firestore(),
      companyProvinces: [],
      zones: [],
      selectedProvince: {
        id: "",
        name: "",
      },
      allProvinceSelected: false,
      inRequest: false,
      branchOfficeService: new BranchOfficeService(),
      utilService: new UtilsService(),
      branchOfficeCurrentZones: [],
      provinces: []
    };
  },
  methods: {
    async updateZones(){
      this.inRequest = true;
      const selectedZones = this.zones.filter(x => x.selected === true).map(x => x.id);
      console.log('selectedZones ', selectedZones);
      try {
        await this.branchOfficeService
        .update(this.branchOfficeId, {
          zones: selectedZones,
        });
        await this.getCompanyProvinces();
        this.$helpers.toast("Zonas actualizadas");
        this.closeZoneModal();
      } catch (error) {
        console.log("ERR ", error);
        this.$helpers.toast("Error al guardar zonas", "error");
      }
      this.inRequest = false;
    },
    async selectProvince(province) {
      this.selectedProvince = Object.assign({}, province);

      const allZones = await this.utilService.getZonesByProvince(province.id);
      allZones.forEach(x => {
        if(this.branchOfficeCurrentZones.indexOf(x.id) !== -1){
          x.selected = true;
        }
      });
      this.zones = allZones;

      $("#zones-modal").modal({
        keyboard: false,
        backdrop: false,
      });

    },
    closeZoneModal(){
      this.zones.forEach(x => x.selected = false);
      $("#zones-modal").modal('hide');
    },
    async getCompanyProvinces() {
      try {
        const companyData = await this.branchOfficeService.getBranchOfficeData(this.branchOfficeId);
        this.branchOfficeCurrentZones = companyData.zones || [];
        
        this.companyProvinces = companyData.provinces;
      } catch (e) {
        this.$helpers.message(
          "Oops",
          "Error al obtener provincias del suplidor",
          "error"
        );
        console.log("ERR ", e);
      }
    },
    async saveProvinces() {
      this.inRequest = true;
      try {
        await this.updateCompanyProvinces(this.getSelectedProvincesId);
        await this.setProvincesAsAvailable(this.getSelectedProvincesId);
        this.companyProvinces = this.getSelectedProvincesId;
        this.$helpers.toast("Provincia agregada");
        await this.getCompanyProvinces();
        this.closeProvinceModal();
      } catch (e) {
        this.$helpers.toast("Error al guardar provincia", "error");
        console.log("ERR ", e);
      } finally {
        this.inRequest = false;
      }
    },
    async updateCompanyProvinces(provinces) {
      return this.branchOfficeService
      .update(this.branchOfficeId, {
        provinces: provinces,
      });
    },
    setProvincesAsAvailable(provincesId){
      provincesId.forEach(async (id) => {
        await firebase.firestore().collection("Province").doc(id).set({
          available: true
        }, {merge: true});
      });
    },
    openProvinceModal() {
      $("#provinces-modal").modal({
        keyboard: false,
        backdrop: false,
      });
      this.provinces.forEach((p) => {
        if (this.companyProvinces.includes(p.id)) {
          p.selected = true;
        }
      });
    },
    closeProvinceModal() {
      this.unselectProvinces();
      $("#provinces-modal").modal("hide");
    },
    async deleteProvince(province) {
      const ok = await this.$helpers.confirm("Confirme esta acción");
      if (ok) {
        this.companyProvinces.splice(
          this.companyProvinces.indexOf(province.id),
          1
        );
        await this.updateCompanyProvinces(this.companyProvinces.map(x => x.id));
        // TODO: quitar esto de aqui
        const branchOfficesWithThisProvince = await this.db
        .collection('BranchOffices')
        .where('provinces', 'array-contains', province.id)
        .get();
        if(!branchOfficesWithThisProvince || branchOfficesWithThisProvince.docs.length === 0){
          await this.db
            .collection('Province')
            .doc(province.id)
            .update({
              available: false,
              active: false
            });
        }
        this.$helpers.toast("Provincia eliminada");

      }
    },    
    unselectProvinces() {
      this.provinces.forEach((p) => (p.selected = false));
    },
    selectAllProvince() {
      this.allProvinceSelected = !this.allProvinceSelected;
      this.provinces.forEach((p) => (p.selected = this.allProvinceSelected));
    },
    async getProvinces() {
      const res = await this.utilService.getProvinces();
      if(!res.ok){
        this.$helpers.message('Error al cargar provincias', res.message, 'error');
      }else{
        res.data.forEach(x => x.selected = false);
        this.provinces = res.data;
      }
    },
  },
  async mounted() {
    await this.getProvinces();
    await this.getCompanyProvinces();
  },
  computed: {
    myProvinces() {
      return this.provinces.filter((p) => this.companyProvinces.includes(p.id));
    },
    getSelectedProvincesId() {
      return this.provinces.filter((p) => p.selected).map((p) => p.id);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/scss/colors";
</style>
